import db from '@/utils/localstorage'

const TokenKey = 'ACCESS_TOKEN'

export function getToken() {
  return db.get(TokenKey, '')
}

